import Image from 'next/image';
import React, { ReactElement } from 'react';

import { Assets } from '../../../../../utils/assets';
import MaxWidth from '../../../../shared/MaxWidth';
import * as S from './Hero.styles';

export const Hero = (): ReactElement => {
  return (
    <S.Wrapper>
      <S.CircleBlur>
        <Image
          alt={Assets.images.circleOfBlurs.alt}
          fill
          loading="eager"
          priority
          src={Assets.images.circleOfBlurs.url}
        />
      </S.CircleBlur>
      <MaxWidth>
        <S.Content>
          <S.TextBox>
            <S.Caption>We’re about making a positive impact.</S.Caption>
            <S.Description>
              Music is usually made to grab your attention, which leads to distraction.
              <br />
              We create music with a new approach, putting your needs first.
            </S.Description>
          </S.TextBox>
          <S.ImgWrapper>
            <Image
              alt={Assets.images.aboutHero.alt}
              height={423}
              loading="eager"
              src={Assets.images.aboutHero.url}
              width={898}
            />
          </S.ImgWrapper>
        </S.Content>
      </MaxWidth>
    </S.Wrapper>
  );
};
